import { render, staticRenderFns } from "./OldManFile.vue?vue&type=template&id=5c878719&scoped=true&"
import script from "./OldManFile.vue?vue&type=script&lang=js&"
export * from "./OldManFile.vue?vue&type=script&lang=js&"
import style0 from "./OldManFile.vue?vue&type=style&index=0&id=5c878719&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c878719",
  null
  
)

export default component.exports